export default __webpack_public_path__ + "assets/images/282785be1004582541a5e11137113a5d-pending_icon.svg";